/**
 * The "+5" a harder dish wears on its recipe card.
 *
 * Harder dishes pay more (`recipes.json` `dishes[].bonus`), and a player can
 * only weigh a stew against a fried meat if the card says so. The text and
 * tooltip come from `bonusChip` so the docket, the recipe panel and the
 * landing menu all say the same thing; a dish with no bonus renders nothing.
 */

import { bonusChip } from './hudState'

export function BonusChip({ bonus }: { bonus: number | undefined }) {
  const chip = bonusChip(bonus)
  if (!chip) return null
  return (
    <span className="dish-bonus" title={chip.title} aria-label={chip.title} data-testid="dish-bonus">
      {chip.text}
    </span>
  )
}
